import type { ProductPriceFragmentFragment } from '@packages/gql/generated/shopping/graphql';

/* GraphQL */ `
  fragment GetGlycerinPriceFragment on ProductPrice {
    value
    valueOld
    currency
  }
`;

export type GetGlycerinPriceProps = Pick<
  ProductPriceFragmentFragment,
  'value' | 'valueOld' | 'currency'
>;

export const getGlycerinPrice = (price: GetGlycerinPriceProps) => {
  const { currency, value, valueOld } = price;

  return {
    displayedPrice: value,
    currency,
    originalPrice: valueOld || undefined,
  };
};
